export default function Accueil() {
  return <h1>Bienvenue sur notre site !</h1>;
}